import React from 'react';

const ReceiptChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 13.9h6v2H9v-2zm0-4h6v2H9v-2zm-3-3v13.3L8 19l2 1.1 2-1.1 2 1.1 2-1.1 2 1.1V6.8H6zM4 3.9h16v2H4z"
        />
    </svg>
);

ReceiptChunkySvg.displayName = 'ReceiptChunkySvg';
export default ReceiptChunkySvg;
